/* eslint-disable guard-for-in,no-restricted-syntax,no-param-reassign */
import { Injectable } from '@angular/core';
import { VariablesResource } from '../../account/resources/variables.resource';
import { Variables } from '../../package-designer/package.models';

export interface PackageVariable {
  key: string;
  keyDisabled: boolean;
  hideButtons: boolean;
  setDefault: boolean;
  changed: boolean;
  value: string;
  defaultValue: string;
}

@Injectable({
  providedIn: 'root',
})
export class PackageVariablesService {
  defaultVariables: PackageVariable[] = [];

  constructor(private variablesResource: VariablesResource) {}

  // eslint-disable-next-line class-methods-use-this
  objectToArrayOfObjects(obj: Variables, defaults = {}): PackageVariable[] {
    const arrayOfObjects = [];

    for (const key in obj) {
      const variable = {
        key,
        keyDisabled: false,
        hideButtons: false,
        setDefault: false,
        changed: false,
        value: obj[key],
        defaultValue: obj[key],
      };

      arrayOfObjects.push(variable);
    }

    for (const key in defaults) {
      arrayOfObjects.forEach(function (variable) {
        if (variable.key === key) {
          variable.defaultValue = defaults[key];
          variable.changed = defaults[key] !== obj[key];
        }
      });
    }

    return arrayOfObjects;
  }

  getDefaultVariables(callback) {
    if (this.defaultVariables.length === 0) {
      this.variablesResource.get().subscribe((data) => {
        this.defaultVariables = this.objectToArrayOfObjects(data);

        callback(this.defaultVariables);
      });
    } else {
      callback(this.defaultVariables);
    }
  }

  separateVariables(variables, defaults, callback) {
    const variablesObject = {
      userVariables: [],
      systemVariables: [],
    };

    const checkIfIsSystemVariable = (variable) => {
      let isSystemVariable = false;

      this.defaultVariables.forEach((defaultVariable, index) => {
        if (defaultVariable.key === variable.key) {
          isSystemVariable = true;
          variablesObject.systemVariables[index].value = variable.value;
          variablesObject.systemVariables[index].changed = true;
        }
      });

      return isSystemVariable;
    };

    const defineVariable = function (variable) {
      if (!checkIfIsSystemVariable(variable)) {
        variablesObject.userVariables.push(variable);
      }
    };

    this.getDefaultVariables((defaultVariables) => {
      variablesObject.systemVariables = [...defaultVariables];

      const variablesArray = this.objectToArrayOfObjects(variables || {}, defaults || {});

      variablesArray.forEach((item) => defineVariable(item));

      callback(variablesObject);
    });
  }

  combineVariables(variablesObject) {
    const variables = {};

    const systemDefaultHasChanged = (systemVariable) => {
      let hasChanged = false;

      this.defaultVariables.forEach((defaultVariable) => {
        if (defaultVariable.key === systemVariable.key) {
          hasChanged = defaultVariable.value !== systemVariable.value;
        }
      });

      return hasChanged;
    };

    variablesObject.userVariables.forEach((userVariable) => {
      variables[userVariable.key] = userVariable.value;
    });

    variablesObject.systemVariables.forEach((systemVariable) => {
      if (systemDefaultHasChanged(systemVariable)) {
        variables[systemVariable.key] = systemVariable.value;
      }
    });

    return variables;
  }
}
